<template>
      <a :href="to" @click.prevent="click()"><slot></slot></a>
</template>

<script>
export default {
  props: ['to', 'func', 'funcParams'],
  data () {
    return {
    }
  },
  methods: {
    click:function(){

      if(this.to) {
        this.routePush(this.to, {item:'a', to:this.to});
      } else if(this.func) {
        if ( Array.isArray(this.funcParams) ){
          this.func.apply(this,this.funcParams);
        } else {
          this.func.apply(this,[this.funcParams]);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";

</style>



// WEBPACK FOOTER //
// src/components/elements/KmsA.vue